import { Loader } from "@googlemaps/js-api-loader"

class ActivitiesMap {
  constructor(mapEl) {
    this.mapEl = mapEl;

    this.settingsMap = this.mapEl.getAttribute('data-activities-map') ? JSON.parse(this.mapEl.getAttribute('data-activities-map')) : undefined;

    this.centerLat = this.settingsMap?.center.lat || undefined;
    this.centerLng = this.settingsMap?.center.lng || undefined;
    this.centerZoom = this.settingsMap?.center.zoom || undefined;

    this.points = [];

    document.querySelectorAll('[data-point]').forEach(pointEl => {
      if(pointEl.getAttribute('data-lat') && pointEl.getAttribute('data-lng'))
        this.points.push({
          title: pointEl.getAttribute('data-point'),
          link: pointEl.getAttribute('data-link'),
          countryCode: pointEl.getAttribute('data-country-code'),
          lat: parseFloat(pointEl.getAttribute('data-lat')),
          lng: parseFloat(pointEl.getAttribute('data-lng')),
          latlng: pointEl.getAttribute('data-lat').replace('.', '') + pointEl.getAttribute('data-lng').replace('.', ''),
        });
    });


    const groupByLatLng = this._groupBy(['latlng']);
    this.pointsGrouped = groupByLatLng(this.points);

    this.init();
  }

  _groupBy(keys) {
    return function(array) {
      return array.reduce(function(objectsByKeyValue, obj) {
        var value = keys.map(function(key){return (obj[key])}).join('-');
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {})
    }
  }

  init() {
    const loader = new Loader({
      apiKey: ENV.GOOGLE_MAPS_API_KEY,
      v: 'quarterly'
    });

    loader.load().then(async () => this._initMap() );
  }

  async _initMap () {
    const { Map, InfoWindow } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    const parser = new DOMParser();

    let centerPoint, firstPoint;

    if(this.pointsGrouped.length > 0) {
      firstPoint = this.pointsGrouped[0];
      centerPoint = (this.centerLat && this.centerLng)
        ? { lat: parseFloat(this.centerLat), lng: parseFloat(this.centerLng) }
        : { lat: parseFloat(firstPoint.lat), lng: parseFloat(firstPoint.lng) };

      const itineraryCoordinates = this.pointsGrouped.map(point => {
        return { lat: parseFloat(point.lat), lng: parseFloat(point.lng), id: point.id };
      });
    }

    this.map = new Map(this.mapEl, {
      center: centerPoint ? centerPoint : { lat: 40.2810678, lng: -7.5041701 },
      zoom: this.centerZoom || 17,
      fullscreenControl: false,
      mapId: '9f314cc895e62670',
    });

    const infoWindow = new InfoWindow();

    for (const [key, point] of Object.entries(this.pointsGrouped)) {
      this._addMarker(point, infoWindow, AdvancedMarkerElement, parser);
    }
  }

  _addMarker(point, infoWindow, AdvancedMarkerElement, parser) {
    const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon fill="black" points="16.6 36 16.6 24.2 16.9 20.4 16.9 15.5 16.6 11.7 16.6 0 19.3 0 19.3 11.8 19.1 15.5 19.1 20.4 19.3 24.2 19.3 36 16.6 36"/><polygon fill="black" points="0 16.6 11.8 16.6 15.5 16.9 20.4 16.9 24.2 16.6 36 16.6 36 19.3 24.2 19.3 20.4 19.1 15.5 19.1 11.7 19.3 0 19.3 0 16.6"/><polygon fill="black" points="4.3 29.8 12.6 21.4 15.5 18.9 18.9 15.5 21.4 12.6 29.8 4.3 31.7 6.2 23.4 14.5 20.5 17 17 20.5 14.5 23.4 6.2 31.7 4.3 29.8"/><polygon fill="black" points="6.2 4.3 14.5 12.6 17 15.5 20.5 18.9 23.4 21.4 31.7 29.8 29.8 31.7 21.4 23.4 18.9 20.5 15.5 17 12.6 14.5 4.3 6.2 6.2 4.3"/></svg>';
    const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

    const marker = new AdvancedMarkerElement({
      position: { lat: point[0].lat, lng: point[0].lng },
      map: this.map,
      content: pinSvg,
    });

    const contentString = point.reduce((accumulator, activity) => {
      if(activity.link)
        return accumulator + `<p><a href="${activity.link}">${activity.title}${activity.countryCode ? '<sup>'+activity.countryCode+'</sup>' : ''}</a></p>`;
      else
        return accumulator + `<p>${activity.title}${activity.countryCode ? '<sup>'+activity.countryCode+'</sup>' : ''}</p>`;
    }, '');

    marker.addListener("click", ({ domEvent, latLng }) => {
      const { target } = domEvent;

      infoWindow.close();
      infoWindow.setContent(contentString);
      infoWindow.open(marker.map, marker);
    });

  }
}

export default ActivitiesMap;
